import { graphql } from '@/generated/gql';

export const DEMAND_REQUEST_QUERY = graphql(/* GraphQL */ `
  query TsrctDemandRequest($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        requestedBy
        status
        demandRequest {
          id
          budget
          demandId
          summary
          currency
          createdAt
          externalReference
          commodityGroupId
          sourceReferences {
            internalId
            isPrimary
            sourceReference
            url
            sourceSystem {
              id
              name
            }
          }
          lineItems {
            id
            position
            title
            description
            deliveryLocationId
            organizationId
            unitId
            quantity
            shipmentTerms {
              earlyDeliveryAt
              lateDeliveryAt
            }
            updatedAt
            preferredSupplierId
            internalId
            expectedPricePerUnit
            commodityGroupId
            contractItemId
            commodityId
            baselinePricePerUnit
            analysisId
          }
        }
        permissions {
          read
          write
          assign
        }
      }
    }
  }
`);
